import { lazy } from '@/service/lazy'

export default [{
  name: 'Roteiros Operacionais',
  path: 'roteiro',
  id: 'roteiro',
  icon: 'fa fa-file-text-o',
  component: lazy('app/default/gerenciador/roteiro/index'),
  meta: { requireAuth: true, rules: ['gerenciar_roteiros'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/roteiro.js